/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {useMemo} from 'react';
import {GenericObject} from '@ion/core/src/types/entities';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';

/**
 * The useServiceEnablementFeatures hook provides the features of service enablements.
 *
 * ```typescript
 * import {useServiceEnablementFeatures} from '@ion/packages/query/src/hooks';
 *  ...
 *  const serviceMappings = useServiceEnablementFeatures(Features);
 *
 */
export const useServiceEnablementFeatures = (featuresEntity: GenericObject) => {
  const serviceFeature = useMemo(() => {
    const extendedAttribute   = featuresEntity?.getAllApplicationFeaturesList();
    const applicationFeatures = safeJSONParse(extendedAttribute);

    return applicationFeatures?.filter((feature) =>
      featuresEntity?.hasServiceEnablementFeature(feature?.id)
    );
  }, [featuresEntity]);

  return serviceFeature;
};

export default useServiceEnablementFeatures;
